import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addEncounter = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    // '/api/method/technoerp.services.create_encounter',
    '/api/resource/Patient Encounter',
    body
  );
  return data;
});
export const submitEncounter = catchAsync(async (name) => {
  const { data } = await axiosInstance.post(
    `/api/method/technoerp.services.submit_doc?type=Patient Encounter&name=${name}`
  );
  return data;
});
export const updateEncounter = catchAsync(async (id, body) => {
  const { data } = await axiosInstance.put(
    // '/api/method/technoerp.services.update_encounter',
    `/api/resource/Patient Encounter/${id}`,
    body
  );
  return data;
});
export const getEncounters = catchAsync(async ({ value, key }) => {
  let baseUrl = `/api/resource/Patient Encounter?fields=["name", "docstatus", "practitioner_name", "medical_department", "encounter_date", "patient_name", "encounter_time", "encounter_comment"]&limit_start=0&limit_page_length=0&order_by=name desc`;
  if (value) {
    // const filterData = key === "encounter_date" ? [["encounter_date","Between",[`"${value}"`,`"${value}"`]]] : value
    const filterData = value;
    // console.log(filterData,"filterData");
    if (key === 'encounter_date') {
      baseUrl += `&filters=[["encounter_date","Between",["${value}","${value}"]]]`;
    } else {
      baseUrl += `&filters=[["${key}","like","%${filterData}%"]]`;
    }
  }
  const { data } = await axiosInstance.get(
    baseUrl
    // '/api/method/technoerp.services.get_encounters'
  );
  return data;
});
export const getLastEncounters = catchAsync(async (patient) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_patient_encounters?patient=${patient}`
  );
  return data;
});
export const getSymptoms = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_symptoms'
  );
  return data;
});
export const getDiagnosis = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_diagnosis'
  );
  return data;
});
export const getMaterials = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_materials'
  );
  return data;
});

export const getEncountersDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    // `/api/method/technoerp.services.get_encounter?encounter=${id}`
    `/api/resource/Patient Encounter/${id}`
  );
  return data;
});

export const deleteEncounters = catchAsync(async (id) => {
  const { data } = await axiosInstance.delete(
    // `/api/method/technoerp.services.delete_record?record=${id}&document=Patient Encounter`
    `/api/resource/Patient Encounter/${id}`
  );
  return data;
});
